// Client directory: people who checked in or have billing details.
export const clientesDir = {
  title: "Clients",
  subtitle: "Everyone who has checked in or has billing details. They are saved automatically and never duplicated.",
  searchLabel: "Search client",
  searchPlaceholder: "Name, document, email or phone",
  filters: {
    todos: "All",
    checkin: "With check-in",
    fiscal: "With tax details",
    reservas: "With bookings",
  },
  cols: {
    client: "Client",
    document: "Document",
    phone: "Phone",
    stays: "Stays",
    lastStay: "Last stay",
  },
  checkins: "{n} check-in | {n} check-ins",
  bookings: "{n} booking | {n} bookings",
  fiscalBadge: "Tax",
  noDocument: "No document",
  noName: "No name",
  emptyTitle: "No clients yet",
  emptyText: "Everyone who completes a check-in will show up here automatically.",
  emptySearch: "No clients match “{q}”.",
  loadError: "Clients could not be loaded.",
  pageOf: "{from}–{to} of {total}",
  prev: "Previous",
  next: "Next",
  docTypes: {
    P: "Passport",
    ID: "National ID",
    IM: "NIE",
    I: "ID card",
    D: "National ID",
    N: "NIE",
    X: "Residence permit",
    CC: "Citizenship card",
    CE: "Foreigner ID card",
    TI: "Identity card",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Close",
    createBooking: "Create booking",
    personal: "Personal details",
    document: "Document",
    address: "Address",
    fiscal: "Tax details",
    noFiscal: "No tax details. They are added when invoicing or from Invoicing → Tax customers.",
    defaultProfile: "Default",
    bookings: "Bookings",
    noBookings: "No linked bookings.",
    companions: "Has travelled with",
    noCompanions: "Has not shared a booking with anyone else.",
    timesTogether: "{n} time | {n} times",
    invoices: "Invoices",
    noInvoices: "No invoices.",
    viewPdf: "View PDF",
    email: "Email",
    phone: "Phone",
    birthDate: "Date of birth",
    sex: "Sex",
    nationality: "Nationality",
    docType: "Type",
    docNumber: "Number",
    expiry: "Expiry",
    support: "Support number",
    street: "Address",
    zip: "Postal code",
    city: "City",
    country: "Country of residence",
    roleCheckin: "Check-in",
    roleHolder: "Holder",
    loadError: "The client record could not be opened.",
  },
  sexes: {
    M: "Male",
    F: "Female",
  },
  picker: {
    missingPolice: "No police details are saved for this client in this account. Fill them in now and they will be kept for next time.",
    searchSaved: "Search saved client",
    searchPlaceholder: "Name, document or phone…",
    noResults: "No saved client matches.",
    selected: "Details filled in from Clients",
    clear: "Remove",
  },
  match: {
    title: "This client already exists",
    text: "{name} is already saved in Clients. You can fill in all their details with one tap.",
    use: "Use their details",
    dismiss: "Not this person",
    applied: "{name}'s details filled in. Check the stay dates and sign.",
    companionsTitle: "Previously travelled with",
    companionsHint: "Tap a person to register them with their details.",
    registerCompanion: "Register {name}",
  },
};
